import {Component} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationsService} from "../../../services/notifications.service";

@Component({
  selector: 'password-reset-confirm',
  templateUrl: './password-reset-confirm.component.html'
})
export class PasswordResetConfirmComponent {
  password: string;
  errors: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private notificationsService: NotificationsService,
  ) {
  }

  setPassword() {
    const uid = this.route.snapshot.paramMap.get('uid');
    const token = this.route.snapshot.paramMap.get('token');
    this.errors = {};
    this.authService
      .setPassword(uid, token, this.password)
      .subscribe(
        _ => this.showSuccess(),
        response => this.errors = JSON.parse(response.error)
      );
  }

  showSuccess() {
    this.notificationsService.show('Twoje hasło zostało zmienione pomyślnie. Możesz się zalogować.');
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/auth/password-reset-confirm/password-reset-confirm.component.ts